(function () {
  'use strict';
  if (window.TamimiPicks || !window.TamimiPicksEngine) return;
  const node = document.getElementById('tamimi-picks-context');
  if (!node) return;
  let context;
  try { context = JSON.parse(node.textContent); } catch (_) { return; }
  if (!context.enabled && !context.editor) return;
  const engine = window.TamimiPicksEngine;
  const STORE = 'tamimi:picks:v1';
  const root = String(context.root || '/').replace(/\/?$/, '/');
  const controllers = new Map();
  const requests = new Map();
  const pendingAdds = new Map();
  let preferences = false, analytics = false, cart = [], cartPromise = null, cartKnown = false, lastCartRead = 0, privacyReady = false;
  if (Array.isArray(context.cart)) { cart = context.cart.map(item => ({...compact(item), quantity: Number(item.quantity) || 1})); cartKnown = true; lastCartRead = Date.now(); }
  let profile = {views: [], query: null};
  let revision = 0;
  const api = {version: engine.version, status: 'starting'};
  window.TamimiPicks = api;
  function url(path, params) {
    const value = new URL(root + path.replace(/^\//, ''), location.origin);
    Object.entries(params || {}).forEach(([key, v]) => value.searchParams.set(key, String(v)));
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) value.searchParams.set('preview_theme_id', preview);
    return value;
  }
  function compact(p) {
    return {id: String(p.id || ''), handle: String(p.handle || '').slice(0, 180), title: String(p.title || '').slice(0, 240), type: String(p.type || '').slice(0, 100), vendor: String(p.vendor || '').slice(0, 80), price: Number(p.price) || 0, tags: String(p.tags || '').slice(0, 500), groups: Array.isArray(p.groups) ? p.groups.slice(0, 8) : [], at: Number(p.at) || Date.now()};
  }
  function loadProfile() {
    profile = {views: [], query: null};
    if (!preferences) return;
    try {
      const saved = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (!saved || saved.v !== 1) return;
      profile.views = Array.isArray(saved.views) ? saved.views.filter(v => v && v.id && Date.now() - Number(v.at) < 30 * 86400000).slice(0, 20).map(compact) : [];
      if (saved.query && typeof saved.query.value === 'string' && Date.now() - Number(saved.query.at) < 86400000) profile.query = {value: saved.query.value.slice(0, 120), at: saved.query.at};
    } catch (_) { profile = {views: [], query: null}; }
  }
  function persist() {
    if (!preferences || context.editor) return;
    try { localStorage.setItem(STORE, JSON.stringify({v: 1, views: profile.views.slice(0, 20), query: profile.query})); } catch (_) { return; }
  }
  function remember(p) {
    if (!preferences || context.editor || !p?.id) return;
    const value = compact(p);
    profile.views = [value, ...profile.views.filter(v => String(v.id) !== String(value.id))].slice(0, 20);
    persist();
  }
  function recordPage() {
    if (!preferences || context.editor) return;
    if (context.product) remember(context.product);
    if (context.page === 'search' && context.query && !/@|\d{7,}/.test(context.query)) {
      profile.query = {value: String(context.query).slice(0, 120), at: Date.now()};
      persist();
    }
  }
  function emit(name, details) {
    if (!analytics || context.editor || document.visibilityState === 'hidden') return;
    const data = {section: 'tamimi_home_picks', engine_version: engine.version, ...details};
    try {
      const result = window.Shopify?.analytics?.publish(name, data);
      if (result?.catch) result.catch(() => {});
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({event: name, ...data});
    } catch (_) { return; }
  }
  async function get(address, type) {
    const response = await fetch(address, {credentials: 'same-origin', signal: AbortSignal.timeout(6500), headers: {'Accept': type === 'json' ? 'application/json' : 'text/html'}});
    if (!response.ok) throw new Error('Request failed');
    return type === 'json' ? response.json() : response.text();
  }
  async function readCart(force = false) {
    if (cartPromise) return cartPromise;
    if (!force && cartKnown && Date.now()-lastCartRead < 250 && !pendingAdds.size) return cart;
    cartPromise = (async () => {
      try {
        const result = await get(url('cart.js'), 'json');
        cartKnown = true; lastCartRead = Date.now();
        cart = (result.items || []).map(item => ({...compact({id: item.product_id, handle: item.handle, title: item.product_title, type: item.product_type, vendor: item.vendor, price: item.final_price}), quantity: item.quantity}));
        recordSourceAdds(result.items || []);
        pendingAdds.clear();
        api.cart = cart.map(p => p.id);
        return cart;
      } catch (_) { return cart; }
      finally { cartPromise = null; }
    })();
    return cartPromise;
  }
  function currentProfile() {
    return {views: preferences ? profile.views : [], query: preferences ? profile.query : null, purchased: preferences ? context.purchased || [] : [], cart};
  }
  function parseCards(container) {
    const result = [];
    for (const card of container.querySelectorAll('[data-tamimi-pick]')) {
      try {
        const product = JSON.parse(card.dataset.tamimiPick);
        if (product.id && card.classList.contains('productgrid--item')) result.push({product, card});
      } catch (_) { continue; }
    }
    return result;
  }
  async function source(query, collectionPage = false) {
    const sourceSection = collectionPage ? 'tamimi-picks-collection-source' : 'tamimi-picks-source';
    const key = sourceSection + ':' + query.type + ':' + query.value;
    if (requests.has(key)) return requests.get(key);
    const request = (async () => {
      try {
        const address = query.type === 'collection'
          ? url('collections/' + encodeURIComponent(query.value), {section_id: sourceSection, sort_by: 'best-selling'})
          : url('search', {q: query.value, type: 'product', 'options[unavailable_products]': 'hide', section_id: sourceSection});
        const html = await get(address, 'html');
        return parseCards(new DOMParser().parseFromString(html, 'text/html'));
      } catch (_) { requests.delete(key); return []; }
    })();
    requests.set(key, request);
    return request;
  }
  function reveal(controller) {
    clearTimeout(controller.section.tamimiPicksWatchdog);
    delete controller.section.dataset.picksPending;
    if (!controller.section.dataset.picksFirstVisibleMs) controller.section.dataset.picksFirstVisibleMs = String(Math.round(performance.now()));
  }
  function cleanCard(card) {
    const clone = card.cloneNode(true);
    ['position','left','right','transform'].forEach(property=>clone.style.removeProperty(property));
    clone.classList.remove('is-selected');
    clone.removeAttribute('aria-hidden');
    return clone;
  }
  function refreshNative(controller, ordered) {
    controller.ranked = ordered;
    ordered = pageOrder(controller, ordered);
    const current = parseCards(controller.section);
    const before = current.map(entry => String(entry.product.id)).join(',');
    const count = controller.section.querySelector('[data-tamimi-picks-count]');
    if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang).format(ordered.length);
    if (before === ordered.map(p => String(p.id)).join(',')) return;
    const existing = new Map(current.map(entry => [String(entry.product.id), entry.card]));
    if (controller.page && current.length === ordered.length && ordered.every(p => existing.has(String(p.id)))) {
      controller.grid.append(...ordered.map(p => existing.get(String(p.id))));
      return;
    }
    const nodes = ordered.map(p => controller.cards.get(String(p.id))?.card && cleanCard(controller.cards.get(String(p.id)).card)).filter(Boolean);
    if (!nodes.length) return;
    const wrapper = controller.section.closest('.shopify-section');
    const detail = {sectionId: controller.section.dataset.section};
    controller.reloading = true;
    const height = controller.grid.getBoundingClientRect().height;
    if (height > 0) controller.grid.style.minHeight = height + 'px';
    wrapper.dispatchEvent(new CustomEvent('shopify:section:unload', {bubbles: true, detail}));
    controller.grid.replaceChildren(...nodes);
    for (const card of nodes) {
      card.style.removeProperty('position');card.style.removeProperty('left');card.style.removeProperty('right');card.style.removeProperty('transform');
      card.classList.remove('is-selected');
    }
    wrapper.dispatchEvent(new CustomEvent('shopify:section:load', {bubbles: true, detail}));
    controller.grid.dispatchEvent(new CustomEvent('theme:rimg:watch', {bubbles: true}));
    controller.reloading = false;
    controller.section.dataset.picksMounts = String((Number(controller.section.dataset.picksMounts) || 0) + 1);
    requestAnimationFrame(() => requestAnimationFrame(() => controller.grid.style.removeProperty('min-height')));
  }
  function idleTurn() {
    return new Promise(resolve => window.requestIdleCallback ? window.requestIdleCallback(resolve, {timeout: 150}) : setTimeout(resolve, 0));
  }
  async function waitForInteraction(controller, runRevision) {
    while (controller.section.isConnected && runRevision === revision) {
      const focused = controller.grid.contains(document.activeElement);
      if (!controller.pointerDown && !focused && Date.now()-(controller.interactionAt || 0) > 500) return true;
      await new Promise(resolve => setTimeout(resolve, 80));
    }
    return false;
  }
  function pageOrder(controller, products) {
    if (!controller.page) return products;
    const sort = new URLSearchParams(location.search).get('sort_by');
    const ordered = [...products];
    if (sort === 'price-ascending') ordered.sort((a,b) => a.price-b.price);
    if (sort === 'price-descending') ordered.sort((a,b) => b.price-a.price);
    if (sort === 'title-ascending') ordered.sort((a,b) => a.title.localeCompare(b.title, document.documentElement.lang));
    if (sort === 'title-descending') ordered.sort((a,b) => b.title.localeCompare(a.title, document.documentElement.lang));
    return ordered;
  }
  const PICKS_CACHE = 'tamimi:ai:collection:v1';
  function collectionCache(payload) {
    if (!preferences || context.editor) return null;
    try {
      const saved = JSON.parse(sessionStorage.getItem(PICKS_CACHE) || 'null');
      if (saved && Date.now()-saved.at < 5*60000 && saved.key === cacheKey(payload) && saved.result?.enabled && saved.result.arm !== 'control') return saved;
    } catch (_) {}
    return null;
  }
  function cacheKey(payload) {
    return JSON.stringify({locale:document.documentElement.lang,root,views:payload.views,query:payload.query,purchased:payload.purchased,cart:payload.cart,analytics:payload.analytics});
  }
  function saveCollectionCache(payload, result, controller, savedAt) {
    if (!preferences || context.editor) return;
    try {
      const previous = collectionCache(payload);
      const markup = previous?.markup || {};
      const view = controller.page ? 'collection' : 'home';
      const html = result.products.map(p => {const card=controller.cards.get(String(p.id))?.card;return card ? cleanCard(card).outerHTML : '';}).join('');
      if (html.length < 1500000) markup[view] = html;
      sessionStorage.setItem(PICKS_CACHE, JSON.stringify({at:savedAt || Date.now(),key:cacheKey(payload),result,markup}));
    } catch (_) {}
  }
  function recommendationPayload() {
    let sessionToken = null;
    if (preferences && analytics) {try {sessionToken=localStorage.getItem(AI_SESSION);} catch (_) {}}
    const inputs = currentProfile();
    return {preferences,analytics,sessionToken,views:preferences?inputs.views.map(p=>String(p.id)):[],query:preferences?inputs.query?.value||'':'',purchased:preferences?inputs.purchased.map(p=>String(p.id)):[],cart:inputs.cart.map(p=>String(p.id))};
  }
  let aiResult = null, aiCartToken = null, aiEventQueue = [], aiEventTimer = 0, sendingEvents = false;
  const AI_SESSION = 'tamimi:ai:session:v2';
  const OUTBOX = 'tamimi:ai:outbox:v2', SOURCES = 'tamimi:ai:sources:v2';
  const sourceTouches = new Map();
  const tracking = api.tracking = {pending: 0, discarded: 0, lastError: null, storageAvailable: true};
  function persistOutbox() {
    tracking.pending = aiEventQueue.length;
    try { sessionStorage.setItem(OUTBOX, JSON.stringify(aiEventQueue)); }
    catch (_) { tracking.storageAvailable = false; }
  }
  function persistSources() {
    try { localStorage.setItem(SOURCES, JSON.stringify([...sourceTouches])); }
    catch (_) { tracking.storageAvailable = false; }
  }
  function loadTracking() {
    try {
      const pending = JSON.parse(sessionStorage.getItem(OUTBOX) || '[]');
      if (Array.isArray(pending)) aiEventQueue = pending.filter(e => e && typeof e.id === 'string' && typeof e.receipt === 'string' && e.receipt.length <= 2048 && ['impression','click','add'].includes(e.kind) && /^\d+$/.test(e.productId) && Number.isFinite(e.at) && Date.now()-(e.queuedAt || e.at) < 8*86400000).slice(-200);
      const sources = JSON.parse(localStorage.getItem(SOURCES) || '[]');
      if (Array.isArray(sources)) for (const pair of sources.slice(-60)) {
        if (!Array.isArray(pair)) continue;
        const [id, source] = pair;
        if (/^\d+$/.test(id) && typeof source?.receipt === 'string' && source.receipt.length <= 2048 && Number.isFinite(source.at) && Date.now()-source.at < 7*86400000) sourceTouches.set(id, source);
      }
    } catch (_) { tracking.storageAvailable = false; }
    persistOutbox(); persistSources();
    flushEvents();
    if (sourceTouches.size) readCart(true);
  }
  async function aiPost(path, value, keepalive = false) {
    const response = await fetch(url('apps/tamimi-ai/' + path), {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(value), signal: AbortSignal.timeout(6000), keepalive});
    if (!response.ok) { const error = new Error('AI unavailable'); error.status = response.status; throw error; }
    const result = await response.json();
    if (path === 'recommendations' && Number.isFinite(result.serverTime)) result.clockOffset = result.serverTime-Date.now();
    return result;
  }
  function aiEvent(kind, productId, receipt = aiResult?.receipt, clockOffset = aiResult?.clockOffset || 0) {
    if (!preferences || !analytics || context.editor || !receipt) return;
    const event = {id: window.crypto?.randomUUID?.() || Date.now().toString(36)+'-'+Math.random().toString(36).slice(2), kind, productId: String(productId), at: Date.now()+clockOffset, queuedAt: Date.now(), receipt, attempt: 0};
    // A click is not manufactured into a view. These are separate observations.
    aiEventQueue.push(event);
    if (aiEventQueue.length > 200) { tracking.discarded += aiEventQueue.length-200; aiEventQueue.splice(0, aiEventQueue.length-200); }
    persistOutbox();
    clearTimeout(aiEventTimer);
    if (kind === 'click') flushEvents();
    else aiEventTimer = setTimeout(flushEvents, 80);
  }
  async function flushEvents() {
    if (sendingEvents || !preferences || !analytics || context.editor || !aiEventQueue.length) return;
    sendingEvents = true;
    const receipt = aiEventQueue[0].receipt;
    const batch = aiEventQueue.filter(e => e.receipt === receipt).slice(0, 40);
    for (const event of batch) event.attempt = (event.attempt || 0)+1;
    persistOutbox();
    let retry = false;
    try {
      const response = await aiPost('events', {receipt, events: batch.map(({receipt, ...event}) => event)}, true);
      const ids = new Set(response.version === 2 ? [...(response.acknowledged || []), ...(response.rejected || [])] : batch.map(e => e.id));
      tracking.discarded += (response.rejected || []).length;
      aiEventQueue = aiEventQueue.filter(e => !ids.has(e.id));
      tracking.lastError = null;
      retry = batch.some(e => !ids.has(e.id));
    } catch (error) {
      tracking.lastError = error.status || 'network';
      if (error.status === 400 || error.status === 401) {
        const ids = new Set(batch.map(e => e.id));
        tracking.discarded += batch.length;
        aiEventQueue = aiEventQueue.filter(e => !ids.has(e.id));
      } else retry = true;
    } finally {
      sendingEvents = false; persistOutbox();
      if (preferences && analytics && aiEventQueue.length) {
        clearTimeout(aiEventTimer);
        aiEventTimer = setTimeout(flushEvents, retry ? Math.min(30000, 1000 * 2 ** Math.min(5, batch[0].attempt-1)) : 80);
      }
    }
  }
  function rememberSource(id, receipt, clockOffset = 0) {
    if (!preferences || !analytics || !receipt) return;
    const quantity = cart.filter(p => p.id === String(id)).reduce((n,p) => n+p.quantity, 0);
    sourceTouches.set(String(id), {receipt, at: Date.now(), quantity, clockOffset});
    if (sourceTouches.size > 60) sourceTouches.delete(sourceTouches.keys().next().value);
    persistSources();
  }
  function recordSourceAdds(items) {
    if (!preferences || !analytics) return;
    for (const [id, source] of sourceTouches) {
      if (Date.now()-source.at >= 7*86400000) {sourceTouches.delete(id);continue;}
      const quantity = items.filter(i => String(i.product_id) === id).reduce((n,i) => n+Number(i.quantity || 0), 0);
      if (quantity > Number(source.quantity || 0)) {
        aiEvent('add', id, source.receipt, source.clockOffset || 0);
        emit('tamimi_picks_add_to_cart', {product_id:id, source:'after_section_click'});
      }
      source.quantity = quantity;
    }
    persistSources();
  }
  window.addEventListener('online', () => {flushEvents();refresh();});
  window.addEventListener('pagehide', () => {persistOutbox();flushEvents();});
  async function aiCartLink(token) {
    if (!analytics || context.editor || token === aiCartToken) return;
    try {
      const response = await fetch(url('cart/update.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{tamimi_ai_session__:token||''}}),keepalive:true});
      if (!response.ok) throw new Error('Cart linkage failed');
      if (analytics) aiCartToken = token;
    } catch (_) {aiCartToken=null;tracking.lastError='cart_link';}
  }
  function applyAvailability(controller, result) {
    const wrapper = controller.section.closest('.shopify-section');
    if (!result.enabled || result.arm === 'control') {
      wrapper.hidden = !controller.page;
      controller.section.dataset.recommendationStatus = result.enabled ? 'control' : 'app-disabled';
      return false;
    }
    wrapper.hidden = false;
    return true;
  }
  async function mountAiResult(controller, result, payload, runRevision, cached) {
    if (!controller.section.isConnected || runRevision !== revision) return false;
    if (!applyAvailability(controller, result)) {reveal(controller);return true;}
    if (controller.section.dataset.picksTimedOut === 'true') return true;
    const products = Array.isArray(result.products) ? result.products.filter(p => /^\d+$/.test(p.id) && typeof p.handle === 'string' && p.handle.length <= 180 && /^[\p{L}\p{N}-]+$/u.test(p.handle)).slice(0,40) : [];
    const view = controller.page ? 'collection' : 'home';
    const markup = cached?.markup?.[view];
    if (typeof markup === 'string' && markup.length < 1500000) {
      await idleTurn();
      const allowed = new Set(products.map(p => p.id));
      for (const entry of parseCards(new DOMParser().parseFromString(markup, 'text/html'))) {
        if (allowed.has(String(entry.product.id))) controller.cards.set(String(entry.product.id), entry);
      }
    }
    const missing = products.filter(p => !controller.cards.has(String(p.id)));
    const chunks=[];for(let i=0;i<missing.length;i+=18)chunks.push(missing.slice(i,i+18));
    const htmls=await Promise.all(chunks.map(chunk=>get(url('search',{q:'tamimi-picks:|'+chunk.map(p=>p.handle).join('|'),type:'product',section_id:controller.page?'tamimi-picks-collection-source':'tamimi-picks-source'}),'html')));
    if (!controller.section.isConnected || runRevision !== revision) return false;
    for (const html of htmls) {
      await idleTurn();
      for (const entry of parseCards(new DOMParser().parseFromString(html,'text/html'))) controller.cards.set(String(entry.product.id), entry);
    }
    const ordered = products.map(p => controller.cards.get(String(p.id))?.product).filter(p => p && p.available !== false);
    if (!ordered.length) return false;
    if (!await waitForInteraction(controller, runRevision)) return false;
    await idleTurn();
    if (!controller.section.isConnected || runRevision !== revision) return false;
    if (cacheKey(payload) !== cacheKey(recommendationPayload())) {controller.again=true;return true;}
    aiResult = result;
    controller.receipt = result.receipt;
    if (result.sessionToken && preferences && analytics) {try{localStorage.setItem(AI_SESSION,result.sessionToken);}catch(_){}}
    refreshNative(controller, ordered);
    reveal(controller);
    controller.section.dataset.recommendationStatus = result.mode;
    controller.section.dataset.recommendationCount = String(ordered.length);
    controller.section.dataset.picksSource = cached ? 'cache' : 'network';
    controller.section.dataset.picksReadyMs = String(Math.round(performance.now()));
    api.status = result.mode;api.version = result.version;
    controller.section.querySelectorAll('[data-tamimi-pick]').forEach(card => { card.tamimiReceipt = result.receipt;card.tamimiClockOffset=result.clockOffset || 0; });
    observeAiCards(controller);
    if (result.cartToken) aiCartLink(result.cartToken);
    saveCollectionCache(payload, {...result,products:products.filter(p=>ordered.some(o=>String(o.id)===p.id))}, controller, cached?.at);
    return true;
  }
  async function aiUpdate(controller, runRevision) {
    if (!context.ai || context.editor) return false;
    const payload = recommendationPayload();
    const cached = collectionCache(payload);
    controller.section.dataset.picksRequests = String((Number(controller.section.dataset.picksRequests) || 0) + 1);
    const prefetched = controller.section.tamimiPicksPrefetch;
    const request = prefetched?.key === cacheKey(payload) ? prefetched.promise : aiPost('recommendations', payload).then(result => ({result}), error => ({error}));
    delete controller.section.tamimiPicksPrefetch;
    let restored = false;
    if (cached) restored = await mountAiResult(controller, cached.result, payload, runRevision, cached);
    const fresh = await request;
    if (!controller.section.isConnected || runRevision !== revision) return true;
    if (fresh.error) {if (restored) return true;throw fresh.error;}
    if (Number.isFinite(fresh.result.serverTime) && !Number.isFinite(fresh.result.clockOffset)) fresh.result.clockOffset=fresh.result.serverTime-Date.now();
    if (!applyAvailability(controller, fresh.result)) {aiResult = null;reveal(controller);return true;}
    if (restored) return true;
    return mountAiResult(controller, fresh.result, payload, runRevision, null);
  }
  function observeAiCards(controller) {
    controller.aiObserver?.disconnect();controller.aiClear?.();
    if (!analytics || !aiResult?.receipt || !window.IntersectionObserver) return;
    const timers=new Map();
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const card=entry.target;clearTimeout(timers.get(card));
      if(entry.isIntersecting&&entry.intersectionRatio>=.5)timers.set(card,setTimeout(()=>{if(document.visibilityState==='visible'){try{aiEvent('impression',JSON.parse(card.dataset.tamimiPick).id,card.tamimiReceipt,card.tamimiClockOffset || 0);}catch(_){}observer.unobserve(card);}},1000));
    }),{threshold:[.5]});
    controller.section.querySelectorAll('[data-tamimi-pick]').forEach(card=>observer.observe(card));
    controller.aiObserver=observer;controller.aiClear=()=>{timers.forEach(clearTimeout);timers.clear();};
  }

  async function update(controller, force = false) {
    if (!controller.section.isConnected || context.editor) return;
    if (!privacyReady) {controller.requested = true;return;}
    if (controller.busy) {controller.again = true;return;}
    controller.busy = true;
    const runRevision = revision;
    controller.section.setAttribute('aria-busy', 'true');
    try {
      if (!cartKnown) await readCart();
      const inputKey = cacheKey(recommendationPayload());
      if (!force && controller.inputKey === inputKey && Date.now()-(controller.checkedAt || 0) < 5*60000) return;
      controller.inputKey = inputKey; controller.checkedAt = Date.now();
      if(context.ai && !context.editor){try{if(await aiUpdate(controller,runRevision))return;}catch(_){controller.section.dataset.aiFallback='true';controller.section.closest('.shopify-section').hidden=false;}}
      const inputs = currentProfile();
      const contextual = preferences ? engine.sourceQueries(inputs) : [];
      const queries = contextual.length ? contextual : [{type: 'collection', value: 'our-selection'}, {type: 'collection', value: 'chargers-cables-qatar'}, {type: 'collection', value: 'audio-accessories'}];
      const loaded = await Promise.allSettled(queries.map(query => source(query, controller.page)));
      if (!controller.section.isConnected || runRevision !== revision) return;
      for (const result of loaded) if (result.status === 'fulfilled') for (const entry of result.value) controller.cards.set(String(entry.product.id), entry);
      const products = [...controller.cards.values()].map(e => e.product);
      const ordered = engine.rank(products, inputs, {limit: Number(controller.section.dataset.count) || 36});
      if (!await waitForInteraction(controller, runRevision)) return;
      refreshNative(controller, ordered);
      reveal(controller);
      controller.section.dataset.recommendationStatus = contextual.length ? 'personalized' : 'curated';
      controller.section.dataset.recommendationCount = String(ordered.length);
      api.status = controller.section.dataset.recommendationStatus;
    } catch (_) { reveal(controller);controller.section.dataset.recommendationStatus = 'fallback';api.status = 'fallback'; }
    finally {
      controller.busy = false;
      controller.section.removeAttribute('aria-busy');
      if ((runRevision !== revision || controller.again) && controller.section.isConnected) {controller.again=false;update(controller);}
    }
  }
  function observeImpression(controller) {
    let timer = 0, seen = false;
    if (!window.IntersectionObserver) return;
    const observer = new IntersectionObserver(entries => {
      clearTimeout(timer);
      if (seen || !entries.some(e => e.isIntersecting) || !analytics) return;
      timer = window.setTimeout(() => {
        if (document.visibilityState !== 'visible') return;
        const products = parseCards(controller.section).map(e => String(e.product.id));
        emit('tamimi_picks_view', {product_ids: products, count: products.length});
        seen = true;observer.disconnect();
      }, 1000);
    }, {threshold: .25});
    observer.observe(controller.section);
    controller.impressions = observer;
    controller.clearTimer = () => clearTimeout(timer);
  }
  function initialize(section) {
    const id = section.dataset.section;
    if (controllers.get(id)?.section === section) return;
    const grid = section.querySelector('[data-tamimi-picks-grid]');
    if (!grid) return;
    const controller = {section, grid, requested: true, ranked: parseCards(section).map(e=>e.product), page: section.dataset.picksPage === 'true', cards: new Map(parseCards(section).map(e => [String(e.product.id), {product: e.product, card: e.card.cloneNode(true)}])), busy: false, reloading: false};
    controllers.set(id, controller);
    // Parser-restored cards can be clicked before a new network result mounts.
    if (section.dataset.picksEarlyReadyMs && preferences && analytics) {
      const saved = collectionCache(recommendationPayload());
      if (saved?.result?.receipt) {
        const ids = new Set(saved.result.products.map(p => String(p.id)));
        section.querySelectorAll('[data-tamimi-pick]').forEach(card => {
          try {if(ids.has(String(JSON.parse(card.dataset.tamimiPick).id))){card.tamimiReceipt=saved.result.receipt;card.tamimiClockOffset=saved.result.clockOffset || 0;}}catch(_){}
        });
      }
    }
    section.dataset.picksMainInitMs = String(Math.round(performance.now()));
    const paint = performance.getEntriesByType?.('paint').find(entry=>entry.name === 'first-contentful-paint');
    if (paint) section.dataset.picksFirstPaintMs = String(Math.round(paint.startTime));
    if (!section.dataset.picksEarlyReadyMs) {
      section.dataset.recommendationStatus = 'server';
      section.dataset.picksSource = 'server';
      if (!context.editor) section.dataset.picksPending = 'true';
    }
    observeImpression(controller);
    if (context.editor) { section.dataset.recommendationStatus = 'editor-preview';return; }
    update(controller);
  }
  function start() { document.querySelectorAll('[data-tamimi-home-picks]').forEach(initialize); }
  async function refresh(force = false) {
    if (!controllers.size && !sourceTouches.size) return;
    await readCart();
    await Promise.all([...controllers.values()].filter(c=>c.requested).map(c=>update(c, force)));
  }
  let refreshTimer = 0;
  function scheduleRefresh() {clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>readCart(true).then(()=>refresh()),120);}
  function consentChanged() {
    const privacy = window.Shopify?.customerPrivacy;
    const nextPreferences = !context.editor && Boolean(privacy?.preferencesProcessingAllowed?.());
    const nextAnalytics = !context.editor && Boolean(privacy?.analyticsProcessingAllowed?.());
    if (privacyReady && preferences === nextPreferences && analytics === nextAnalytics) return;
    const hadReceipt = aiResult?.receipt;
    let hadSession = false;try{hadSession=Boolean(localStorage.getItem(AI_SESSION));}catch(_){}
    preferences = nextPreferences; analytics = nextAnalytics; privacyReady = true;
    if (context.ai && !context.editor && (!preferences || !analytics)) {
      if (hadReceipt) aiPost('forget',{receipt:hadReceipt},true).catch(()=>{});
      try{localStorage.removeItem(AI_SESSION);}catch(_){}
      aiResult=null;aiEventQueue=[];sourceTouches.clear();clearTimeout(aiEventTimer);
      try {sessionStorage.removeItem(OUTBOX);localStorage.removeItem(SOURCES);} catch (_) {}
      tracking.pending=0;
      if (hadReceipt || hadSession) {aiCartToken=null;fetch(url('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{tamimi_ai_session__:''}}),keepalive:true}).catch(()=>{});}
    }
    revision++;
    loadProfile();
    if (!preferences && !context.editor) {try{localStorage.removeItem(STORE);sessionStorage.removeItem(PICKS_CACHE);}catch(_){}requests.clear();}
    recordPage();
    if (preferences && analytics) loadTracking();
    for (const controller of controllers.values()) {
      controller.impressions?.disconnect();controller.clearTimer?.();observeImpression(controller);
      controller.inputKey = null;
      if (controller.requested) update(controller);
    }
  }
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('submit', event => {
    if (!preferences || context.editor || !(event.target instanceof HTMLFormElement)) return;
    const input = event.target.querySelector('input[name="q"]');
    if (!input?.value || /@|\d{7,}/.test(input.value)) return;
    profile.query = {value: input.value.slice(0, 120), at: Date.now()};persist();
  }, true);
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const card = target?.closest('[data-tamimi-pick]');
    const section = card?.closest('[data-tamimi-home-picks]');
    if (!card || !section) return;
    const controller = controllers.get(section.dataset.section);
    if (controller?.draggedAt && Date.now()-controller.draggedAt < 600) return;
    let product;
    try { product = JSON.parse(card.dataset.tamimiPick); } catch (_) { return; }
    const position = [...section.querySelectorAll('[data-tamimi-pick]')].indexOf(card) + 1;
    const quick = target.closest('[data-quick-buy]');
    if (quick || target.closest('a[href]')) {
      remember(product);
      const receipt = card.tamimiReceipt || controller?.receipt;
      rememberSource(product.id, receipt, card.tamimiClockOffset || 0);
      emit('tamimi_picks_click', {product_id: String(product.id), position});
      aiEvent('click', product.id, receipt, card.tamimiClockOffset || 0);
    }
    if (quick) {
      pendingAdds.set(String(product.id), {position, at: Date.now()});
      window.setTimeout(refresh, 800);window.setTimeout(refresh, 1800);
    }
  }, true);
  function watchDetailAdd(event) {
    if (!preferences || !analytics || !sourceTouches.size) return;
    const target = event.target instanceof Element ? event.target : null;
    const form = target?.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (event.type === 'click' && !target.closest('button[type="submit"],input[type="submit"],[name="add"],[data-product-atc]')) return;
    window.setTimeout(() => readCart(true), 800);
    window.setTimeout(() => readCart(true), 1800);
  }
  document.addEventListener('submit', watchDetailAdd, true);
  document.addEventListener('click', watchDetailAdd, true);
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:build'].forEach(name => document.addEventListener(name, scheduleRefresh));
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => {
    const id = event.detail?.sectionId;
    const controller = controllers.get(id);
    if (!controller || controller.reloading) return;
    controller.lazy?.disconnect();controller.impressions?.disconnect();controller.clearTimer?.();controller.aiObserver?.disconnect();controller.aiClear?.();controllers.delete(id);
  });
  window.addEventListener('pageshow', event => {flushEvents();if(event.persisted)refresh();});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});else start();
  if (!context.editor) {
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],()=>consentChanged());
      setTimeout(()=>{if(!privacyReady && !window.Shopify?.customerPrivacy)consentChanged();},1500);
    } else consentChanged();
  }
  function interaction(event) {
    const section = event.target instanceof Element ? event.target.closest('[data-tamimi-home-picks]') : null;
    const controller = controllers.get(section?.dataset.section);
    if (controller) {controller.interactionAt=Date.now();if(event.type==='pointerdown'){controller.pointerDown=true;controller.pointerStart={x:event.clientX,y:event.clientY};controller.draggedAt=0;}}
  }
  ['pointerdown','wheel','keydown'].forEach(type=>document.addEventListener(type,interaction,{capture:true,passive:true}));
  document.addEventListener('pointermove',event=>{for(const c of controllers.values())if(c.pointerDown && c.pointerStart && Math.hypot(event.clientX-c.pointerStart.x,event.clientY-c.pointerStart.y)>8)c.draggedAt=Date.now();},{capture:true,passive:true});
  ['pointerup','pointercancel'].forEach(type=>document.addEventListener(type,()=>{for(const c of controllers.values())if(c.pointerDown){c.pointerDown=false;c.interactionAt=Date.now();if(c.draggedAt)c.draggedAt=Date.now();}},{capture:true,passive:true}));
  const validSorts = new Set(['manual','price-ascending','price-descending','title-ascending','title-descending']);
  function sortCollection(controller, value) {
    if (!validSorts.has(value)) return;
    const address = new URL(location.href);address.searchParams.set('sort_by',value);address.searchParams.delete('page');
    history.replaceState(history.state,'',address);
    if (window.Shopify?.queryParams) window.Shopify.queryParams.sort_by=value;
    refreshNative(controller, controller.ranked);
    const select = controller.section.querySelector('[data-productgrid-trigger-sort]');
    if (select) select.value=value;
    const trigger = controller.section.querySelector('[data-productgrid-modal-sort]');
    if (trigger) {trigger.textContent=select?.selectedOptions[0]?.textContent.trim()||trigger.textContent;trigger.setAttribute('aria-expanded','false');}
    const panel = controller.section.querySelector('.tamimi-sort-dropdown');
    if (panel && !panel.hidden && trigger) trigger.click();
    if (panel) panel.hidden=true;
    controller.section.querySelectorAll('[data-productgrid-trigger-sort-button]').forEach(button=>{button.classList.toggle('utils-sortby--modal-button--active',button.value===value);});
  }
  document.addEventListener('change',event=>{
    const select=event.target instanceof Element ? event.target.closest('[data-productgrid-trigger-sort]') : null;
    const section=select?.closest('[data-picks-page="true"]');
    const controller=controllers.get(section?.dataset.section);
    if(!controller)return;
    event.preventDefault();event.stopImmediatePropagation();sortCollection(controller,select.value);
  },true);
  document.addEventListener('click',event=>{
    const button=event.target instanceof Element ? event.target.closest('[data-sort-value],[data-productgrid-trigger-sort-button]') : null;
    if(!button)return;
    const wrapper=button.closest('.shopify-section');
    const section=wrapper?.querySelector('[data-picks-page="true"]');
    const controller=controllers.get(section?.dataset.section);
    if(!controller)return;
    event.preventDefault();event.stopImmediatePropagation();sortCollection(controller,button.dataset.sortValue||button.value);
  },true);
  api.refresh = () => refresh(true);
})();
